<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button icon="md-refresh" @click="refresh">刷新</Button>
      <div class="search-filter">
        <Poptip placement="top-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="订单编号" field="ordersNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNum" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单状态" field="ordersState" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFormData.ordersStateList"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'ordersStateOption')"
                      placeholder="全部"
                  >
                    <Option
                        v-for="option in ordersStateOption"
                        :value="option.value"
                        :key="option.value"
                    >{{ option.label }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
<!--              <vxe-form-item title="审核状态" field="auditState" span="12">-->
<!--                <template v-slot>-->
<!--                  <Select-->
<!--                      v-model="searchFormData.auditState"-->
<!--                      filterable-->
<!--                      clearable-->
<!--                      :default-label="[]"-->
<!--                      :loading="searchLoading"-->
<!--                      :max-tag-count="1"-->
<!--                      :max-tag-placeholder="maxTagPlaceholder"-->
<!--                      @on-set-default-options="(file) => setDefaultOptions(file, 'auditStateOption')"-->
<!--                      placeholder="全部"-->
<!--                  >-->
<!--                    <Option-->
<!--                        v-for="option in auditStateOption"-->
<!--                        :value="option.value"-->
<!--                        :key="option.value"-->
<!--                    >{{ option.label }}-->
<!--                    </Option>-->
<!--                  </Select>-->
<!--                </template>-->
<!--              </vxe-form-item>-->
              <vxe-form-item title="业务类型" field="busType" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.busType"
                      :options="contractListType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人" field="buyerIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchBuyerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'buyerNameOptions', 'twoOrders', 'searchCondition', 1)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'buyerNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in buyerNameOptions" :value="option.id" :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人" field="sellerIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerNameOptions', 'twoOrders', 'searchCondition', 4)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'sellerNameOptions')"
                      placeholder="输入承运人"
                  >
                    <Option
                        v-for="option in sellerNameOptions"
                        :value="option.name"
                        :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.goodsName" placeholder="输入货名"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运地" field="beginPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.beginPlace"
                      placeholder="输入起运地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运时间" field="beginTime" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.beginTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达地" field="endPlace" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.endPlace" placeholder="输入车船号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达时间" field="endTime" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.endTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUserIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'createUserOptions', 'twoOrders', 'searchCondition', 7)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
                      placeholder="输入创建人"
                  >
                    <Option
                        v-for="option in createUserOptions"
                        :value="option.id"
                        :key="option.name"
                    >{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      type="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
                  >重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="orderListData"
          :filter-config="{ remote: true }"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="130">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.id)">{{ row.ordersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersState" title="订单状态" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.ordersState | ordersStateMap }}</span>
          </template>
        </vxe-table-column>
<!--        <vxe-table-column field="auditState" title="审核状态" width="100">-->
<!--          <template slot-scope="{ row }">-->
<!--            <span>{{ row.auditState | auditStateMap }}</span>-->
<!--          </template>-->
<!--        </vxe-table-column>-->
        <vxe-table-column field="busType" title="业务类型" width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.busTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="托运人名称" width="200" align="center"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称" width="200" align="center"></vxe-table-column>

        <vxe-table-column field="goodsName" title="货名" width="105" align="center">
        </vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="60" align="center">
        </vxe-table-column>
        <vxe-table-column field="goodsCounts" title="数量" width="75" align="center">
        </vxe-table-column>
        <vxe-table-column field="priceType" title="计费方式" width="60" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.priceType | priceTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerPrice" title="单价" width="90" align="center">
        </vxe-table-column>
        <vxe-table-column field="sellerAmount" title="总金额" width="120" align="center">
        </vxe-table-column>

        <vxe-table-column field="carShipNum" title="车船号" width="150" align="center">
          <template slot-scope="{ row }">
            <a v-if="row.logisticsType === 1" @click="showCarDetail(row)">{{ row.carShipNum }}</a>
            <a v-if="row.logisticsType === 2" @click="showShipDetail(row)">{{ row.carShipNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="150" align="center">
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.beginTime">{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="150" align="center">
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.endTime">{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="realCount" title="实际数量" width="150" align="center" show-overflow>
        </vxe-table-column>
        <vxe-table-column field="payAmount" title="应付账款" width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="unpayAmount" title="未付金额" width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.unpayAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerInvoiceAmount" title="发票金额" width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.sellerInvoiceAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100" v-if="isHavePermission('platMatchingOrder:createUser')"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120" v-if="isHavePermission('platMatchingOrder:createTime')">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="createCarVisible"
        :title="createCarTitle"
        width="1400"
        height="860"
        @close="closeCarCreate"
        resize
        position="center"
    >
      <create-car-modal
          @afterSave="closeCarCreateModal"
          ref="modalCarCreate"
          @close="closeCar"
      ></create-car-modal>
    </vxe-modal>
    <vxe-modal
        v-model="createShipVisible"
        :title="createShipTitle"
        width="1400"
        height="900"
        @close="closeShipCreate"
        resize
        position="center"
        destroy-on-close
    >
      <create-ship-modal
          @afterSave="closeShipCreateModal"
          @close="createShipVisible = false"
          ref="modalShipCreate"
      ></create-ship-modal>
    </vxe-modal>
  </div>
</template>
<script>

import {isEmpty} from "@/utils/util";
import $api from "@/apiProvider";
import {SEARCH_TIME} from "@/filters/time";
import $C from "@/consts";
import moment from "moment";
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    CreateCarModal,
    CreateShipModal,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      searchVisible: false,
      loading: false,
      orderListData: [],
      searchFormData: {
        ordersNum: null,
        busType: null,
        ordersStateList: null, // 订单状态
        auditState: null,
        goodsName: null,
        carShipNum: null,
        beginPlace: null,
        beginTime: null,
        endPlace: null,
        endTime: null,
        buyerIdList: null,
        sellerIdList: null,
        userIdList: null,
        createTime: null,
      },
      searchLoading: false,
      searchBuyerName: [], // 搜索托运人字段
      buyerNameOptions: [], // 搜索托运人下拉框
      searchSellerName: [], // 搜索承运人字段
      sellerNameOptions: [], // 搜索承运人下拉框
      searchCreateUser: [], // 搜索创建人字段
      createUserOptions: [], // 搜索创建人下拉框
      timeOptions: SEARCH_TIME.options,
      auditStateOption: $C.AUDIT_STATE.options,
      ordersStateOption: $C.ORDERS_STATE.options,
      contractListType: [],
      paramsObj: {
        page: 1,
        rows: 10,
        orderBy: 2,
        platformCompanyIdListOut: [2, 3]
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: "",
      createShipTitle: "",
      open: false,
    }
  },
  watch: {
    "searchFormData.beginTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("beginTime");
      },
    },
    "searchFormData.endTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("endTime");
      },
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  mounted() {
    this.getDicDate();
  },
  methods: {
    openOrderDetail(id) {
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/platMatching/orderDetail/${id}`,
      };
      window.open(obj.path);
    },
    async getDicDate() {
      this.contractListType = [];
      $api.other.getOrderBusTypeModelTwo
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.encoded),
              };
              this.contractListType.push(obj);
              this.getListData();
            });
          });
    },
    handleChange(date) {
      this.timeVal = date;
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    refresh() {
      this.getSearchListKey();
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    handlePageChange(e) {
      // 分页
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.getListData(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getListData();
      }
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};

      Object.keys(obj).forEach((key) => {
        if (
            obj[key] !== null &&
            key !== "beginTime" &&
            key !== "endTime" &&
            key !== "invoiceDate" &&
            key !== "createTime" &&
            obj[key] !== undefined
        ) {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["beginTime"] && obj["beginTime"].length > 0) {
          paramsObj.beginTimeBegin = moment(obj.beginTime[0]).valueOf(); // 开始时间
          paramsObj.beginTimeEnd = moment(obj.beginTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["endTime"] && obj["endTime"].length > 0) {
          paramsObj.endTimeBegin = moment(obj.endTime[0]).valueOf(); // 开始时间
          paramsObj.endTimeEnd = moment(obj.endTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      paramsObj.orderBy = 6;
      paramsObj.platformCompanyIdListOut = [2, 3];

      this.page.currentPage = 1;
      this.page.pageSize = 10;
      if (this.searchBuyerName.length > 0) {
        paramsObj.platformCompanyIdList = this.searchBuyerName;
      }
      if (this.searchSellerName.length > 0) {
        paramsObj.sellerNameList = this.searchSellerName;
      }
      if (this.searchCreateUser.length > 0) {
        paramsObj.createUserIdList = this.searchCreateUser;
      }
      delete paramsObj.fileState;
      this.paramsObj = paramsObj;

      this.getListData(paramsObj);
      this.searchVisible = false;
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    async getListData(obj) {
      this.records = [];
      let params = obj
          ? obj
          : {
            page: this.page.currentPage,
            rows: this.page.pageSize,
            orderBy: 2,
            platformCompanyIdListOut: [2, 3]
          };
      this.loading = true;
      this.$store.commit("order2/SET_ORDER_SEARCH_OBJ", params);
      let res = await $api.twoOrders.post("list", params);
      this.loading = false;
      if (res.status === 1) {
        let pageData = res.data;
        this.orderListData = pageData.rows;
        this.orderListData.map((i) => {
          if (i.busType) {
            this.contractListType.map((j) => {
              if (j.value === parseInt(i.busType)) {
                i.busTypeText = j.label;
              }
            });
          }
        });
        //分页
        this.page.currentPage = pageData.pageNum;
        this.page.pageSize = pageData.pageSize;
        this.page.totalResult = pageData.total;
        // 统计
        if (pageData.countData !== "null") {
          this.amount = JSON.parse(pageData.countData);
        }
      }
    },
    reset() {
      this.searchBuyerName = []; // 搜索托运人字段
      this.searchSellerName = []; // 搜索承运人字段
      this.searchCreateUser = []; // 搜索创建人字段

      this.searchFormData = {
        ordersNum: null,
        busType: null,
        ordersStateList: null, // 订单状态
        auditState: null,
        goodsName: null,
        carShipNum: null,
        beginPlace: null,
        beginTime: null,
        endPlace: null,
        endTime: null,
        buyerIdList: null,
        sellerIdList: null,
        userIdList: null,
        createTime: null,
      };
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = "查看车辆信息";
        this.createCarVisible = true;
        this.$nextTick(() => {
          this.$refs.modalCarCreate.init();
          this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
          this.$refs.modalCarCreate.setReadOnly();
        });
      } else {
        this.$XModal.alert({
          message: "暂无车辆信息",
          status: "error",
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = "查看船舶信息";
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
          this.$refs.modalShipCreate.setNoUpdate();
        });
      } else {
        this.$XModal.alert({
          message: "暂无船舶信息",
          status: "error",
        });
      }
    },
    closeCarCreateModal() {
      this.createCarVisible = false;
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    },
  }
}
</script>
<style>

</style>